'use client'

import { SignOutButton, useClerk, useUser } from '@clerk/nextjs'
import { RotateCw, TriangleAlert } from 'lucide-react'
import { Button } from './button'
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip'

export default function MissingScopesAlert({ tooltip }: { tooltip?: boolean }) {
  const { user } = useUser()
  const { signOut } = useClerk()
  const googleScopes = user?.externalAccounts.find(
    (account) => account.provider === 'google',
  )?.approvedScopes

  const notice = () => {
    return (
      <>
        {googleScopes &&
          !googleScopes.includes(
            'https://www.googleapis.com/auth/calendar',
          ) && (
            <div className="flex w-fit items-center justify-between gap-4 text-nowrap rounded-sm bg-rose-50 px-2 py-1">
              <div className="flex items-center gap-2 text-sm text-muted-foreground">
                <TriangleAlert size={18} /> Calendar connection error
              </div>
              <div>
                <SignOutButton redirectUrl="/sign-in">
                  <Button
                    onClick={() => {
                      signOut()
                    }}
                    variant={'link'}
                    className="p-0 text-primary"
                  >
                    <RotateCw /> Reconnect
                  </Button>
                </SignOutButton>
              </div>
            </div>
          )}
      </>
    )
  }
  if (
    googleScopes &&
    !googleScopes.includes('https://www.googleapis.com/auth/calendar')
  ) {
    return (
      <>
        {tooltip && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Button className="flex-shrink-0" size="icon" variant={'ghost'}>
                {' '}
                <TriangleAlert size={18} />
              </Button>
            </TooltipTrigger>
            <TooltipContent className="bg-transparent p-0">
              {notice()}
            </TooltipContent>
          </Tooltip>
        )}

        {!tooltip && notice()}
      </>
    )
  }
}
